import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getAvatarName, getAvatarMetaData, getFullName, getEmailAddress } from '../api/user';
import { Avatar } from './avatar/Avatar';
import { useAuthStore } from '../store/store';
import ClipLoader from 'react-spinners/ClipLoader';
import '../styles/UserProfile.css';

const UserProfile = ({ screenType }) => {
    const uid = useAuthStore(store => store.user?.uid);
    const navigate = useNavigate();
    const isQueryEnabled = !(uid === undefined || uid === null);

    const avatarNameQuery = useQuery({
        queryKey: ['avatarName', uid],
        queryFn: () => getAvatarName(uid),
        enabled: isQueryEnabled,
    });

    const avatarQuery = useQuery({
        queryKey: ['avatar', uid],
        queryFn: () => getAvatarMetaData(uid),
        enabled: isQueryEnabled,
    });

    const userFullNameQuery = useQuery({
        queryKey: ['fullName', uid],
        queryFn: () => getFullName(uid),
        enabled: isQueryEnabled,
    });

    const userEmailQuery = useQuery({
        queryKey: ['email', uid],
        queryFn: () => getEmailAddress(uid),
        enabled: isQueryEnabled,
    });

    // Fetch the current background color.
    const avatarBgColor = avatarQuery.data?.avatarColors?.avatarBackgroundColor || '#b0d1b9';
    const avatarContent = avatarQuery.isLoading
        ? (
            <div>
                <ClipLoader loading={avatarQuery.isLoading} size={100} aria-label='Loading Spinner' />
            </div>
        )
        : (
            <Avatar
                avatarBackgroundColor={avatarBgColor}
                {...avatarQuery.data?.avatarColors}
                {...avatarQuery.data?.avatarStyles}
                width={100}
                height={100}
            />
        );

    return (
        <div className="sidebar-profile">
            <div className='avatar-container' style={{ backgroundColor: avatarBgColor }} onClick={() => navigate('/avatar')} {...(screenType === 'small-screen' ? { 'data-bs-dismiss': 'offcanvas' } : {})}>
                {avatarContent}
            </div>
            <h1 className='username'>{userFullNameQuery.data}</h1>
            <p className='avatar-name'>Avatar Name: {avatarNameQuery.data}</p>
            <p className='user-email email-divider'>{userEmailQuery.data}</p>
        </div>
    );
};

export default UserProfile;
